import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

function safeText(value: string, fallback: string): string {
  return value && value !== fallback ? value : fallback;
}

export function getCustomPaginatorIntl(translate: TranslateService): MatPaginatorIntl {
  const paginatorIntl = new MatPaginatorIntl();

  const applyLabels = () => {
    paginatorIntl.itemsPerPageLabel = safeText(
      translate.instant('paginator.itemsPerPage'),
      'Items por pagina'
    );
    paginatorIntl.nextPageLabel = safeText(translate.instant('paginator.nextPage'), 'Pagina siguiente');
    paginatorIntl.previousPageLabel = safeText(
      translate.instant('paginator.previousPage'),
      'Pagina anterior'
    );
    paginatorIntl.firstPageLabel = safeText(translate.instant('paginator.firstPage'), 'Primera pagina');
    paginatorIntl.lastPageLabel = safeText(translate.instant('paginator.lastPage'), 'Ultima pagina');

    paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number): string => {
      if (length === 0 || pageSize === 0) {
        return `0 ${safeText(translate.instant('paginator.of'), 'de')} ${length}`;
      }
      const startIndex = page * pageSize;
      const endIndex = Math.min(startIndex + pageSize, length);
      return `${startIndex + 1} - ${endIndex} ${safeText(translate.instant('paginator.of'), 'de')} ${length}`;
    };

    paginatorIntl.changes.next();
  };

  applyLabels();
  translate.onLangChange.subscribe(() => applyLabels());

  return paginatorIntl;
}
